module.exports = __webpack_public_path__ + "static/media/textlayer_original.d2068943.jpg";